module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.9aee15fc.jpeg";